import React, { useState } from 'react';
import { FiUser, FiLayout, FiLogOut } from 'react-icons/fi';
import { useLocation } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { signOut } from 'aws-amplify/auth';
import amplifyconfig from '../../../amplifyconfiguration.json';
import { StyleSheetManager } from 'styled-components';
import { SidebarWrapper, MenuList, MenuItem, NavLinkStyled, LogoWrapper, Logo1, Logo2, MenuText } from './SidebarComponents';

// Suppress the warning related to styled-components
const originalError = console.error;
console.error = (...args) => {
  if (args.length > 0 && typeof args[0] === 'string' && args[0].includes('Added non-passive event listener to a scroll-blocking')) {
    return;
  }
  originalError(...args);
};

Amplify.configure(amplifyconfig);

function Sidebar({ children }) {
  const [, setActiveItem] = useState(null);

  const handleItemClick = (index) => {
    setActiveItem(index);
  };

  const handleSignOut = async () => {
    sessionStorage.clear();
    try {
      await signOut();
    } catch (error) {}
  };

  const location = useLocation();

  return (
    <StyleSheetManager shouldForwardProp={(prop) => prop !== 'isactive'}>
      <SidebarWrapper>
        <LogoWrapper>
          <Logo1 className="share-tech-regular">flagpole</Logo1>
          <Logo2 className="share-tech-regular">technologies</Logo2>
        </LogoWrapper>

        <MenuList>
          <MenuItem
            isactive={location.pathname === "/builder"}
            onClick={() => handleItemClick(0)}
          >
            <NavLinkStyled to="/builder">
              <FiLayout />
              <MenuText>Schedule Builder</MenuText>
            </NavLinkStyled>
          </MenuItem>
          <MenuItem
            isactive={location.pathname === "/account"}
            onClick={() => handleItemClick(2)}
          >
            <NavLinkStyled to="/account">
              <FiUser />
              <MenuText>Account</MenuText>
            </NavLinkStyled>
          </MenuItem>
          <MenuItem isactive={location.pathname === "/"}>
            <NavLinkStyled to="/" onClick={handleSignOut}>
              <FiLogOut />
              <MenuText>Log Out</MenuText>
            </NavLinkStyled>
          </MenuItem>
        </MenuList>

        {/* 👇 Footer Section */}
        <div style={{ marginTop: "auto", textAlign: "center", paddingBottom: "1rem" }}>
          {children}
          © 2025 Flagpole Technologies
        </div>
      </SidebarWrapper>
    </StyleSheetManager>
  );
}

export default Sidebar;
